import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetching sport categories
export const fetchSportCategories = createAsyncThunk('sportCategories/fetchSportCategories', async () => {
  const response = await fetch('/api/sports/categories');
  const data = await response.json();
  return data;
});

const sportCategoriesSlice = createSlice({
  name: 'sportCategories',
  initialState: { sportCategories: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSportCategories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSportCategories.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sportCategories = action.payload;
      })
      .addCase(fetchSportCategories.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default sportCategoriesSlice.reducer;